import React from 'react';
import PropTypes from 'prop-types';

import { Link } from './styles';

export default function ButtonLink({ children, ...rest }) {
  return <Link {...rest}>{children}</Link>;
}

// ButtonLink.defaultProps = {
//   color: 'default',
// }

ButtonLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
